import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getMAGAB020, postMAGAB020, putMAGAB020 } from '../../../services/Api';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_MENUS, MESSAGE } from '../../../shared/constants/app';

import jquery from 'jquery';
import 'summernote/dist/summernote-lite.min.js';
import 'summernote/dist/summernote-lite.min.css';
import 'summernote/dist/lang/summernote-ko-KR';

import { ko } from 'date-fns/locale/ko';
import moment from 'moment';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { handleFocus } from '../../../utils';

registerLocale('ko', ko);

const MAGAB020 = () => {
    const startDateRef = useRef();
    const endDateRef = useRef();
    const { id } = useParams();
    const [data, setData] = useState([]);
    const [dsp, setDsp] = useState('N');
    const [isIndefinite, setIsIndefinite] = useState(false);

    const [fileName, setFileName] = useState([]);
    const [fileExist, setFileExist] = useState([]);
    const [files, setFiles] = useState([]);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const editorContents = useRef();
    const editorDentalInfo = useRef();
    const editorInfoOther = useRef();

    useEffect(() => {
        jquery(editorContents.current).summernote({
            height: 300,
            lang: 'ko-KR',
            placeholder: '내용을 입력하세요...',
            toolbar: [
                ['style', ['style']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'picture', 'video']],
                ['view', ['codeview']],
            ],
        });

        jquery(editorDentalInfo.current).summernote({
            height: 300,
            lang: 'ko-KR',
            placeholder: '내용을 입력하세요...',
            toolbar: [
                ['style', ['style']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'picture', 'video']],
                ['view', ['codeview']],
            ],
        });

        jquery(editorInfoOther.current).summernote({
            height: 300,
            lang: 'ko-KR',
            placeholder: '내용을 입력하세요...',
            toolbar: [
                ['style', ['style']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'picture', 'video']],
                ['view', ['codeview']],
            ],
        });
    }, []);

    const navigate = useNavigate();
    useEffect(() => {
        if (id) {
            getMAGAB020(id)
                .then(({ data }) => {
                    setData(data);
                    setDsp(data.dspYN);
                    setStartDate(data.startDate);
                    setEndDate(data.endDate);
                    setIsIndefinite(data.isIndefinite === 'Y');
                    setFileExist(data.bizImages?.split(','));
                    setFileName(data.bizImages?.split(','));

                    if (editorContents.current) {
                        jquery(editorContents.current).summernote('code', data.contents);
                    }
                    if (editorDentalInfo.current) {
                        jquery(editorDentalInfo.current).summernote('code', data.dentalInfo);
                    }
                    if (editorInfoOther.current) {
                        jquery(editorInfoOther.current).summernote('code', data.infoOther);
                    }
                })
                .catch((error) => console.log(error));
        }
    }, [id]);

    const getDropdownValues = (e) => {
        const selectedValue = e.target.value;
        setDsp(selectedValue);
    };

    const handleDateChange = (date, name) => {
        if (name === 'startDate') {
            setStartDate(date);
        } else if (name === 'endDate') {
            setEndDate(date);
        }
    };
    const handleFileChange = (e) => {
        const selectedFiles = e.target.files;
        if (selectedFiles.length > 0) {
            const fileArray = Array.from(selectedFiles);
            const fileSelected = fileArray.map((file) => file.name);

            setFileName((prevFileNames) =>
                Array.isArray(prevFileNames) ? [...prevFileNames, ...fileSelected] : fileSelected,
            );

            setFiles((prev) => [...prev, ...fileArray]);
        }
    };

    const handleRemoveFile = (fileRemove) => {
        if (fileName.length > 0) {
            setFileName((prev) => prev.filter((file) => file !== fileRemove));
        }

        if (files.length > 0) {
            setFiles((prev) => prev.filter((file) => file.name !== fileRemove));
        }

        if (fileExist && fileExist.length > 0) {
            setFileExist((prev) => prev.filter((file) => file !== fileRemove));
        }
    };

    const handleIndefiniteChange = (e) => {
        setIsIndefinite(e.target.checked);
        if (e.target.checked) {
            setStartDate('');
            setEndDate('');
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSave = () => {
        const content = jquery(editorContents.current).summernote('code').trim();
        // validate
        if (!data.agency) {
            alert('모집기관을 입력해 주세요.');
            handleFocus('agency');
            return;
        } else if (!data.dentalOwner) {
            alert('대표자명을 입력해 주세요.');
            handleFocus('dentalOwner');
            return;
        } else if (!data.location) {
            alert('주소를 입력해 주세요.');
            handleFocus('location');
            return;
        } else if (!data.dentalPage) {
            alert('홈페이지를 입력해 주세요.');
            handleFocus('dentalPage');
            return;
        }
        // else if (files.length === 0) {
        //     alert('기관 이미지 선택해 주세요.');
        //     handleFocus('fileInput');
        //     return;
        // }
        else if (!data.title) {
            alert('제목을 입력해 주세요.');
            handleFocus('title');
            return;
        } else if (!data.numberOfPositions) {
            alert('모집인원을 입력해 주세요.');
            handleFocus('numberOfPositions');
            return;
        } else if (!data.certificate) {
            alert('모집직종을 입력해 주세요.');
            handleFocus('certificate');
            return;
        } else if (!data.license) {
            alert('자격요건을 입력해 주세요.');
            handleFocus('license');
            return;
        } else if (!content || content === '<p><br></p>') {
            alert('봉사활동을 입력해 주세요.');
            handleFocus('editorContents');
            return;
        } else if (!isIndefinite && startDate === '') {
            alert('시작일을 선택해 주세요.');
            handleFocus('startDate');
            return;
        } else if (!isIndefinite && endDate === '') {
            alert('종료일을 선택해 주세요.');
            handleFocus('endDate');
            return;
        } else if (!data.applyMethod) {
            alert('지원방법을 입력해 주세요.');
            handleFocus('applyMethod');
            return;
        } else if (!data.contactPerson) {
            alert('담당자명을 입력해 주세요.');
            handleFocus('contactPerson');
            return;
        } else if (!data.contactNumber) {
            alert('담당자 연락처를 입력해 주세요.');
            handleFocus('contactNumber');
            return;
        }
        //  else if (editorDentalInfo && editorDentalInfo.root.innerHTML === '<p><br></p>') {
        //     alert('모집기관 소개 입력해 주세요.');
        //     handleFocus('editorDentalInfo');
        //     return;
        // } else if (editorInfoOther && editorInfoOther.root.innerHTML === '<p><br></p>') {
        //     alert('기타 세부사항 입력해 주세요.');
        //     handleFocus('editorInfoOther');
        //     return;
        // }

        const payload = {
            dspYN: dsp,
            agency: data.agency || '',
            location: data.location || '',
            dentalPage: data.dentalPage || '',
            dentalOwner: data.dentalOwner || '',
            title: data.title || '',
            numberOfPositions: data.numberOfPositions || 1,
            certificate: data.certificate || '',
            license: data.license || '',
            period: data.period || '',
            contents: jquery(editorContents.current).summernote('code'),
            ftsContents: jquery(editorContents.current)
                .summernote('code')
                .replace(/<\/p>/gi, '\n')
                .replace(/<br\/?>/gi, '\n')
                .replace(/<\/?[^>]+(>|$)/g, ''),
            jobLocation: data.jobLocation || '',
            isIndefinite: isIndefinite ? 'Y' : 'N',
            startDate: startDate && isIndefinite !== 'Y' ? moment(startDate).format('YYYY-MM-DD HH:mm:ss') : null,
            endDate: endDate && isIndefinite !== 'Y' ? moment(endDate).format('YYYY-MM-DD HH:mm:ss') : null,
            applyMethod: data.applyMethod || '',
            contactPerson: data.contactPerson || '',
            contactNumber: data.contactNumber || '',
            dentalInfo: jquery(editorDentalInfo.current).summernote('code'),
            infoOther: jquery(editorInfoOther.current).summernote('code'),
        };

        const isConfirmed = window.confirm('등록/수정하시겠습니까?');
        const apiCall = id ? putMAGAB020 : postMAGAB020;
        const message = '등록/수정되었습니다.';
        const formData = new FormData();
        if (id) payload.seq = id;

        formData.append('data', new Blob([JSON.stringify(payload)], { type: 'application/json' }));

        if (Array.isArray(files) && files.length > 0) {
            files.forEach((file, index) => {
                formData.append('files', file);
            });
        }
        if (Array.isArray(fileExist) && fileExist.length > 0) {
            formData.append('fileExists', fileExist.join(','));
        }

        if (isConfirmed) {
            apiCall(formData)
                .then(() => {
                    window.alert(message);
                    navigate('/magab010');
                })
                .catch((error) => {
                    console.log(error);
                    window.alert(MESSAGE.notify.updateError);
                });
        }
    };

    return (
        <div className="container">
            <div className="wrap">
                <SideMenu menu={MENU_MENUS} />
                <div className="content-right">
                    <h1 className="title">{!id ? '자원봉사 등록' : '자원봉사 수정'}</h1>
                    <table className="table member-infor">
                        <tbody>
                            <tr>
                                <th className="border-t-ddd">공개여부</th>
                                <td colSpan={3} className="border-t-ddd">
                                    <select onChange={getDropdownValues} value={dsp}>
                                        <option value="Y">공개</option>
                                        <option value="N">비공개</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th colSpan={4} className="item-dot">
                                    모집 채용광고 내역
                                </th>
                            </tr>
                            <tr>
                                <th>
                                    모집기관 <span style={{ color: '#FF0000' }}>*</span>
                                </th>
                                <td>
                                    <input
                                        name="agency"
                                        type="text"
                                        value={data?.agency || ''}
                                        onChange={handleInputChange}
                                    />
                                </td>
                                <th className="border-l-ddd">
                                    대표자명 <span style={{ color: '#FF0000' }}>*</span>
                                </th>
                                <td>
                                    <input
                                        name="dentalOwner"
                                        type="text"
                                        value={data?.dentalOwner || ''}
                                        onChange={handleInputChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    주소 <span style={{ color: '#FF0000' }}>*</span>
                                </th>
                                <td>
                                    <input
                                        name="location"
                                        type="text"
                                        value={data?.location || ''}
                                        onChange={handleInputChange}
                                    />
                                </td>
                                <th rowSpan={2} className="border-l-ddd">
                                    기관 이미지
                                </th>
                                <td rowSpan={2}>
                                    <div className="group-input-file">
                                        <input type="text" disabled />
                                        <input
                                            type="file"
                                            id="fileInput"
                                            multiple
                                            onChange={handleFileChange}
                                            className="custom-input hidden-file-input"
                                        />
                                        <label htmlFor="fileInput" className="custom-label-file">
                                            파일첨부
                                        </label>
                                    </div>
                                    <div className="result-input-file">
                                        <ul>
                                            {fileName &&
                                                fileName.length > 0 &&
                                                fileName.map((file, index) => (
                                                    <li
                                                        key={file}
                                                        className="file-name"
                                                        onClick={() => handleRemoveFile(file)}
                                                    >
                                                        {file}
                                                    </li>
                                                ))}
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    홈페이지 <span style={{ color: '#FF0000' }}>*</span>
                                </th>
                                <td>
                                    <input
                                        name="dentalPage"
                                        type="text"
                                        value={data?.dentalPage || ''}
                                        onChange={handleInputChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th colSpan={4} className="item-dot">
                                    모집요강
                                </th>
                            </tr>
                            <tr>
                                <th>
                                    제목 <span style={{ color: '#FF0000' }}>*</span>
                                </th>
                                <td>
                                    <input
                                        name="title"
                                        type="text"
                                        value={data?.title || ''}
                                        onChange={handleInputChange}
                                    />
                                </td>
                                <th className="border-l-ddd">
                                    모집인원 <span style={{ color: '#FF0000' }}>*</span>
                                </th>
                                <td>
                                    <input
                                        placeholder="1명 또는 치과의사 1명, 간호사 2명 으로 입력해 주세요."
                                        name="numberOfPositions"
                                        type="text"
                                        value={data?.numberOfPositions}
                                        onChange={handleInputChange}
                                        min={1}
                                        maxLength={200}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    모집직종 <span style={{ color: '#FF0000' }}>*</span>
                                </th>
                                <td>
                                    <input
                                        name="certificate"
                                        type="text"
                                        value={data?.certificate || ''}
                                        onChange={handleInputChange}
                                    />
                                </td>
                                <th className="border-l-ddd">
                                    자격요건 <span style={{ color: '#FF0000' }}>*</span>
                                </th>
                                <td>
                                    <input
                                        name="license"
                                        type="text"
                                        value={data?.license || ''}
                                        onChange={handleInputChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>봉사기간</th>
                                <td>
                                    <input
                                        name="period"
                                        type="text"
                                        value={data?.period || ''}
                                        onChange={handleInputChange}
                                        placeholder="YYYY-MM-DD~YYYY-MM-DD"
                                        maxLength={30}
                                    />
                                </td>
                                <th className="border-l-ddd">봉사지역</th>
                                <td>
                                    <input
                                        name="jobLocation"
                                        type="text"
                                        value={data?.jobLocation || ''}
                                        onChange={handleInputChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    봉사활동 <span style={{ color: '#FF0000' }}>*</span>
                                </th>
                                <td colSpan={3}>
                                    <div style={{ height: '300px' }} name="editorContents" ref={editorContents}></div>
                                </td>
                            </tr>
                            <tr>
                                <th colSpan={4} className="item-dot">
                                    모집기간 및 제출사항
                                </th>
                            </tr>
                            <tr>
                                <th>
                                    모집기간 <span style={{ color: '#FF0000' }}>*</span>
                                </th>
                                <td>
                                    <div className="d-flex align-items-center gap-4">
                                        <div className="d-flex item-checkBox">
                                            <input
                                                type="checkbox"
                                                name="isIndefinite"
                                                id="isIndefinite"
                                                value="Y"
                                                checked={isIndefinite}
                                                onChange={handleIndefiniteChange}
                                            />
                                            <span />
                                            <label className="text-nowrap" htmlFor="isIndefinite">
                                                상시모집
                                            </label>
                                        </div>
                                        <div className="flex group-item">
                                            <div
                                                className="group-datepicker"
                                                style={{
                                                    flexWrap: 'wrap',
                                                }}
                                            >
                                                <div className="datepicker-child">
                                                    <DatePicker
                                                        ref={startDateRef}
                                                        onChange={(date) => handleDateChange(date, 'startDate')}
                                                        locale={'ko'}
                                                        placeholderText={'YYYY/MM/DD'}
                                                        dateFormat={'yyyy/MM/dd'}
                                                        selected={startDate}
                                                        maxDate={endDate || null}
                                                        disabled={isIndefinite}
                                                        id="startDate"
                                                    />
                                                    <i
                                                        className="icon icon-date"
                                                        id="start-date-icon"
                                                        onClick={() => startDateRef.current.setFocus()}
                                                    />
                                                </div>
                                                <span>~</span>
                                                <div className="datepicker-child">
                                                    <DatePicker
                                                        ref={endDateRef}
                                                        onChange={(date) => handleDateChange(date, 'endDate')}
                                                        locale={'ko'}
                                                        placeholderText={'YYYY/MM/DD'}
                                                        dateFormat={'yyyy/MM/dd'}
                                                        selected={endDate}
                                                        minDate={startDate || null}
                                                        disabled={isIndefinite}
                                                        id="endDate"
                                                    />
                                                    <i
                                                        className="icon icon-date"
                                                        id="end-date-icon"
                                                        onClick={() => endDateRef.current.setFocus()}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <th className="border-l-ddd">
                                    지원방법 <span style={{ color: '#FF0000' }}>*</span>
                                </th>
                                <td rows={2}>
                                    <textarea
                                        name="applyMethod"
                                        type="text"
                                        value={data?.applyMethod || ''}
                                        onChange={handleInputChange}
                                        style={{ height: '70px' }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th colSpan={4} className="item-dot">
                                    담당자 정보
                                </th>
                            </tr>
                            <tr>
                                <th>
                                    담당자명 <span style={{ color: '#FF0000' }}>*</span>
                                </th>
                                <td>
                                    <input
                                        name="contactPerson"
                                        type="text"
                                        value={data?.contactPerson || ''}
                                        onChange={handleInputChange}
                                    />
                                </td>

                                <th className="border-l-ddd">
                                    담당자 연락처 <span style={{ color: '#FF0000' }}>*</span>
                                </th>
                                <td>
                                    <input
                                        name="contactNumber"
                                        type="text"
                                        value={data?.contactNumber || ''}
                                        onChange={handleInputChange}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th colSpan={4} className="item-dot">
                                    모집기관 기타정보
                                </th>
                            </tr>
                            <tr>
                                <th>모집기관 소개</th>
                                <td colSpan={3}>
                                    <div
                                        style={{ height: '300px' }}
                                        name="editorDentalInfo"
                                        ref={editorDentalInfo}
                                    ></div>
                                </td>
                            </tr>
                            <tr>
                                <th className="border-l-ddd">기타 세부사항</th>
                                <td colSpan={3}>
                                    <div style={{ height: '300px' }} name="editorInfoOther" ref={editorInfoOther}></div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="bottom-content">
                        <div className="button-form">
                            <Link to={'/magab010'} className="btn btn-primary button-back-to-list">
                                목록
                            </Link>
                        </div>
                        <div className="button-form">
                            <button className="btn btn-primary button-save" onClick={handleSave}>
                                등록/수정
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default MAGAB020;
